export default __webpack_public_path__ + "static/media/gojelly_site_bg_01.5bbbf819.jpg";